const corpus = {
  'Checkout API vía Pagos': {
    all: {
      es: 'Checkout API vía Pagos',
      pt: 'Checkout API via Pagamentos',
      en: 'Checkout API via Payments',
    },

    mlb: {
      es: 'Checkout Transparente vía Pagos',
      pt: 'Checkout Transparente via Pagamentos',
      en: 'Checkout Transparente via Payments',
    },
  },

  'Checkout API vía Orders': {
    all: {
      es: 'Checkout API vía Orders',
      pt: 'Checkout API via Orders',
      en: 'Checkout API via Orders',
    },

    mlb: {
      es: 'Checkout Transparente vía Orders',
      pt: 'Checkout Transparente via Orders',
      en: 'Checkout Transparente via Orders',
    },
  },
};

export function $t(text, siteId, lang) {
  try {
    const keys = corpus[text];

    if (!keys) {
      return '';
    }

    const translations = (keys[siteId.toLowerCase()] || keys.all);
    const result = translations[lang.toLowerCase()] || '';

    return result;
  } catch (error) {
    console.error(error);
    return '';
  }
}
